var negotiatePlaceholder = require('./negotiatePlaceholder');
function createEmptyItem (options) {
	var item = {};
	item[options.valueMember] = null;
	item[options.displayMember] = negotiatePlaceholder(options);
	return item;
}

module.exports = createEmptyItem;